import { triggerAPI, qs } from './util';

const lightbox = document.querySelector('.lightbox');
const optimizerForm = document.forms['optimizer-form'];

function handleFormSubmit(e) {
  e.preventDefault();
  let isFormSubmit = true,
    huspotPayload = {
      fields: [
        {
          name: 'firstname',
          value: `${optimizerForm.fname.value}`
        },
        {
          name: 'email',
          value: optimizerForm.email.value
        },
        {
          name: 'phone',
          value: `${optimizerForm.contact.value}`
        },
        {
          name: 'company',
          value: `${optimizerForm.company.value}`
        },
        {
          name: 'role',
          value: `${optimizerForm.role.value}`
        },
        {
          name: 'message',
          value: `${optimizerForm.message.value}`
        }
      ],
      context: {
        pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
        pageName: 'Razorpay Optimizer'
      },
      legalConsentOptions: {
        consent: {
          // Include this object when GDPR options are enabled
          consentToProcess: true,
          text:
            'I agree to allow Razorpay to store and process my personal data.',
          communications: [
            {
              value: true,
              subscriptionTypeId: 6760497,
              text: 'I agree to receive marketing communications from Razorpay.'
            }
          ]
        }
      }
    };
  if (isFormSubmit) {
    triggerAPI(
      'https://api.hsforms.com/submissions/v3/integration/submit/5558946/7a109deb-a1d0-49bd-8d3b-0f8a74eb3b89',
      'POST',
      response => {
        qs('#optimizer-modal .after-success').classList.add('show');
        qs('#optimizer-modal .optimizer-form').classList.add('hide');
      },
      huspotPayload
    );
  }
}

document
  .querySelector('.hero-video-button')
  .addEventListener('click', event => {
    lightbox.classList.add('active');
    const vid = document.getElementById('optimizer-vid');
    vid.play();
  });

document
  .querySelector('.lightbox-background')
  .addEventListener('click', event => {
    const vid = document.getElementById('optimizer-vid');
    vid.pause();
    lightbox.classList.remove('active');
  });

optimizerForm.addEventListener('submit', handleFormSubmit);
